import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';
import './dealer-code-change.scss';
import EmbeddedDealerCodeChange, { Dealer } from './EmbeddedDealerCodeChange';

function DealerCodeChange(props: {
    baseUrl: string;
    dealers: Dealer[];
    dealerCode?: string;
    error?: boolean;
    role: 'card'|'menu-item';
}): ReactElement {
  return (
    <div className={'dealerCodeChange__body'} role={'dealer-change'} aria-labelledby={'dealer-change-heading'}
         aria-describedby={'dealer-change-description'} aria-live={'assertive'}>
      <h2 className={'dealerCodeChange__title'} id={'dealer-change-heading'}>Change dealer</h2>
      <EmbeddedDealerCodeChange baseUrl={props.baseUrl}
                                onSuccessfulSubmission={() => window.location.reload()}
                                dealers={props.dealers}
                                error={props.error}
                                role={props.role}
      />
    </div>
  );
}

DealerCodeChange.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  dealers : PropTypes.arrayOf(PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
      address: PropTypes.shape({
        line1: PropTypes.string,
        line2: PropTypes.string,
        line3: PropTypes.string,
        line4: PropTypes.string,
        postcode: PropTypes.string,
      }),
      phone: PropTypes.string,
      email: PropTypes.string,
      manufacturerCode: PropTypes.string,
      converter: PropTypes.bool,
      mdpClassification: PropTypes.string
    }
  )),
  error: PropTypes.bool,
};

export default DealerCodeChange;
